import { __rest, __assign } from 'tslib';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import mergeRefs from 'react-merge-refs';
import cn from 'classnames';
import { createTextMaskInputElement } from 'text-mask-core';
import { Input } from '../../input/esm';

var styles = {"textHidden":"masked-input__textHidden_cugyg"};
require('./index.css');

// Символ плейсхолдера не может входить в маску, поэтому вместо пробела используется \u2000
var PLACEHOLDER_CHAR = '\u2000';
var MaskedInput = React.forwardRef(function (_a, ref) {
    var _b;
    var mask = _a.mask, _c = _a.keepCharPositions, keepCharPositions = _c === void 0 ? false : _c, value = _a.value, defaultValue = _a.defaultValue, className = _a.className, onBeforeDisplay = _a.onBeforeDisplay, onChange = _a.onChange, onClear = _a.onClear, restProps = __rest(_a, ["mask", "keepCharPositions", "value", "defaultValue", "className", "onBeforeDisplay", "onChange", "onClear"]);
    var _d = useState(null), inputNode = _d[0], setInputNode = _d[1];
    var textMask = useRef(null);
    var _e = useState(value || defaultValue || ''), inputValue = _e[0], setInputValue = _e[1];
    // Не показываем сырое значение до применения маски
    var _f = useState(true), textHidden = _f[0], setTextHidden = _f[1];
    var update = useCallback(function (newValue) {
        if (newValue === void 0) { newValue = ''; }
        if (textMask.current && inputNode) {
            try {
                textMask.current.update(newValue);
            }
            catch (e) {
                // ignore masking errors
            }
            setInputValue(inputNode.value);
        }
    }, [inputNode]);
    var handleInputChange = useCallback(function (event) {
        update(event.target.value);
        if (onChange) {
            onChange(event, {
                value: event.target.value,
            });
        }
    }, [onChange, update]);
    var handleClear = useCallback(function (event) {
        update('');
        if (onClear)
            onClear(event);
    }, [onClear, update]);
    useEffect(function () {
        if (inputNode) {
            textMask.current = createTextMaskInputElement({
                mask: mask,
                inputElement: inputNode,
                pipe: onBeforeDisplay,
                guide: false,
                keepCharPositions: keepCharPositions,
                showMask: false,
                placeholderChar: PLACEHOLDER_CHAR,
                rawValue: '',
                currentCaretPosition: 0,
                previousConformedValue: '',
            });
        }
    }, [onBeforeDisplay, mask, keepCharPositions, inputNode]);
    useEffect(function () {
        update(value || defaultValue);
    }, [value, update, defaultValue]);
    useEffect(function () {
        setTextHidden(false);
    }, []);
    return (React.createElement(Input, __assign({}, restProps, { className: cn(className, (_b = {}, _b[styles.textHidden] = textHidden, _b)), value: inputValue, onChange: handleInputChange, onClear: handleClear, ref: mergeRefs([ref, setInputNode]) })));
});
MaskedInput.displayName = 'MaskedInput';

export { MaskedInput, PLACEHOLDER_CHAR };
